import _ from 'lodash'

export const mergeObjects = <T>(obj1?: T, obj2?: T) => {
	if (!obj1 || !obj2) {
		return obj1 || obj2
	}
	return _.merge(obj1, obj2)
}
